// src/EndOfTopicAssessmentForm.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomDropzone from "../../components/customDropzone";

const EndOfTopicAssessmentForm = () => {
  const [questions, setQuestions] = useState([
    {
      question: "",
      file: null,
      options: ["", "", "", ""],
      correctOption: null,
    },
  ]);

  const addNewQuestion = () => {
    setQuestions([
      ...questions,
      {
        question: "",
        file: null,
        options: ["", "", "", ""],
        correctOption: null,
      },
    ]);
  };

  const handleQuestionChange = (index, value) => {
    const newQuestions = [...questions];
    newQuestions[index].question = value;
    setQuestions(newQuestions);
  };

  const handleFileChange = (index, acceptedFiles) => {
    const newQuestions = [...questions];
    newQuestions[index].file = acceptedFiles[0];
    setQuestions(newQuestions);
  };

  const handleOptionChange = (qIndex, oIndex, value) => {
    const newQuestions = [...questions];
    newQuestions[qIndex].options[oIndex] = value;
    setQuestions(newQuestions);
  };

  const handleCorrectOptionChange = (qIndex, oIndex) => {
    const newQuestions = [...questions];
    newQuestions[qIndex].correctOption = oIndex;
    setQuestions(newQuestions);
  };

  const navigate = useNavigate();

  return (
    <div className="p-6 bg-white rounded-lg shadow-lg m-5 h-auto">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-[20px] font-bold mb-4 text-[#400167] font-satoshi">
          End of Topic Assessment
        </h1>
        {questions.map((q, qIndex) => (
          <div key={qIndex} className="mb-8">
            <div className="mb-12">
              <label
                className="block text-[#400167] text-[16px] font-semibold mb-3 font-satoshi"
                htmlFor={`question${qIndex}`}
              >
                Question {qIndex + 1}
              </label>
              <input
                id={`question${qIndex}`}
                type="text"
                placeholder="Write course title"
                value={q.question}
                onChange={(e) => handleQuestionChange(qIndex, e.target.value)}
                className="shadow appearance-none border rounded w-[683.89px] py-4 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              />
            </div>
            <div className="mb-20">
              <label
                className="block text-[#400167] text-[16px] font-semibold mb-3 font-satoshi"
                htmlFor={`file${qIndex}`}
              >
                Upload File
              </label>
              <CustomDropzone
                onDrop={(acceptedFiles) =>
                  handleFileChange(qIndex, acceptedFiles)
                }
                file={q.file}
              />
            </div>
            <div className="mb-32">
              <label className="block mb-4 font-satoshi">
                <span className="font-bold text-[20px] text-[#400167]">
                  Options
                </span>{" "}
                <span className="text-[#55465F]">(Tick the right answer)</span>
              </label>
              {q.options.map((option, oIndex) => (
                <>
                  <label className="mr-4 mb-4 text-[#4D4F51]">{`Option ${String.fromCharCode(
                    65 + oIndex
                  )}`}</label>
                  <div
                    key={oIndex}
                    className="flex items-center mb-8  border rounded w-[683.89px] py-2 px-3 my-2"
                  >
                    <input
                      type="text"
                      placeholder="Answer"
                      value={option}
                      onChange={(e) =>
                        handleOptionChange(qIndex, oIndex, e.target.value)
                      }
                      className="appearance-none border-0 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    />
                    <input
                      type="radio"
                      name={`correctOption${qIndex}`}
                      checked={q.correctOption === oIndex}
                      onChange={(e) =>
                        handleCorrectOptionChange(
                          qIndex,
                          oIndex,
                          e.target.value
                        )
                      }
                      className="mr-2"
                    />
                  </div>
                </>
              ))}
            </div>
          </div>
        ))}
        <div className="flex items-center gap-10">
          <button
            className="bg-[#5002D0] hover:bg-purple-700 text-white font-bold py-4 px-4 rounded-full font-satoshi w-[480px]"
            onClick={() => navigate("/lessons/pass-mark")}
          >
            Continue
          </button>
          <button
            onClick={addNewQuestion}
            className="text-[#000000] text-[16px] underline font-semibold font-satoshi"
          >
            Add New Question
          </button>
        </div>
      </div>
    </div>
  );
};

export default EndOfTopicAssessmentForm;
